import {
  ResourceFormFields,
  ResourceTypeEnum,
} from '@/components/resource/ResourceInlineForm';
import { ResourceDTO } from '@/models/Resource';

export const resourceFieldsToDTO = (
  data: ResourceFormFields,
): Partial<ResourceDTO> => {
  const base: Partial<ResourceDTO> = {
    title: data.title,
    isMandatory: data.isMandatory,
    onlyTeacher: data.onlyTeacher,
  };

  if (data.type === ResourceTypeEnum.LINK) {
    return {
      ...base,
      resourceLink: data.resourceLink,
      resourceFile: null,
    };
  }

  return {
    ...base,
    resourceFile: data.resourceFile,
    resourceLink: null,
  };
};
